import React from "react";
import TopNavBar from "components/TopNavBar";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const PortfolioLayout = () => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        backgroundColor: "#f3f3f3",
      }}
    >
      <TopNavBar />

      <Box sx={{ flexGrow: 1 }}>
        <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default PortfolioLayout;
